var _linearGradient, _path, _path2, _linearGradient2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcons8CookerHood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    width: "240px",
    height: "240px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q5atTzA6X7EGyWyWSPe0Da",
    x1: 24,
    x2: 24,
    y1: 5.362,
    y2: 15.321,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#737b80"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#575c61"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q5atTzA6X7EGyWyWSPe0Da)",
    d: "M29.958,16.016H18.042v-9c0-1.105,0.895-2,2-2h7.916c1.105,0,2,0.895,2,2V16.016z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#727d86",
    d: "M45,23H3l15-7.984h12L45,23z"
  })), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "Q5atTzA6X7EGyWyWSPe0Db",
    x1: 24,
    x2: 24,
    y1: 20.979,
    y2: 28.192,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#a1aab3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8f979e"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#Q5atTzA6X7EGyWyWSPe0Db)",
    d: "M3,23.016h42v4c0,0.552-0.448,1-1,1H4c-0.552,0-1-0.448-1-1V23.016z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M30,41c-0.552,0-1-0.448-1-1c0-1.064,0.355-2.001,0.64-2.754C29.825,36.758,30,36.296,30,36 s-0.175-0.758-0.36-1.246C29.355,34.001,29,33.064,29,32c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.698,0.26,1.383,0.511,2.045 C31.762,34.71,32,35.337,32,36s-0.238,1.29-0.489,1.955C31.26,38.617,31,39.302,31,40C31,40.552,30.552,41,30,41z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M36,43c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C35.814,38.062,36,37.451,36,37 s-0.186-1.062-0.381-1.71C35.329,34.333,35,33.249,35,32c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C37.773,35.503,38,36.252,38,37s-0.227,1.497-0.467,2.29C37.271,40.154,37,41.047,37,42C37,42.552,36.552,43,36,43z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M18,41c-0.552,0-1-0.448-1-1c0-1.064,0.355-2.001,0.64-2.754C17.825,36.758,18,36.296,18,36 s-0.175-0.758-0.36-1.246C17.355,34.001,17,33.064,17,32c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.698,0.26,1.383,0.511,2.045 C19.762,34.71,20,35.337,20,36s-0.238,1.29-0.489,1.955C19.26,38.617,19,39.302,19,40C19,40.552,18.552,41,18,41z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M24,43c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C23.814,38.062,24,37.451,24,37 s-0.186-1.062-0.381-1.71C23.329,34.333,23,33.249,23,32c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C25.773,35.503,26,36.252,26,37s-0.227,1.497-0.467,2.29C25.271,40.154,25,41.047,25,42C25,42.552,24.552,43,24,43z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#50e6ff",
    d: "M12,43c-0.552,0-1-0.448-1-1c0-1.249,0.329-2.333,0.619-3.29C11.814,38.062,12,37.451,12,37 s-0.186-1.062-0.381-1.71C11.329,34.333,11,33.249,11,32c0-0.552,0.448-1,1-1s1,0.448,1,1c0,0.953,0.271,1.846,0.533,2.71 C13.773,35.503,14,36.252,14,37s-0.227,1.497-0.467,2.29C13.271,40.154,13,41.047,13,42C13,42.552,12.552,43,12,43z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcons8CookerHood);
export default __webpack_public_path__ + "static/media/icons8-cooker-hood.cb693e6084d46e81692f7f8c691629a7.svg";
export { ForwardRef as ReactComponent };